import axios from 'axios';
import { defineStore } from 'pinia';
import { authStore } from '../stores/auth';

export const invoicesStore = defineStore('invoices-store', {
    state: () => {
        return {
            allInvoices: [],
            totalCount: null,
            loadAll: false,
        };
    },

    getters: {
        invoices(state) {
            return state.allInvoices
                .map((inv) => ({
                    ...inv,
                    uid: window.btoa(`${inv.invoiceId}:${inv.transactionTypeName}`),
                }))
                .sort((a, b) =>
                    new Date(a.expirationDate || 0).getTime() > new Date(b.expirationDate || 0).getTime() ? -1 : 1
                );
        },

        etTotalCount(state) {
            return state.totalCount;
        },

        loadingAll(state) {
            return state.loadAll;
        },
    },

    actions: {
        async fetchInvoices() {
            const response = await axios.get(
                process.env.VUE_APP_API_BASE_URL + 'applicants/me/invoices?getAll=false&readmode=0',
                authStore().authConfig
            );
            try {
                this.allInvoices = response.data.invoices;
                this.totalCount = response.data.totalCount;
            } catch (err) {
                this.allInvoices = '';
                console.error('Error loading Invoices:', err);
                return err;
            }
        },

        async fetchAllInvoices() {
            this.loadAll = true;
            const response = await axios.get(
                process.env.VUE_APP_API_BASE_URL + 'applicants/me/invoices?getAll=true&readmode=0',
                authStore().authConfig
            );
            try {
                this.allInvoices = response.data.invoices;
                this.loadAll = false;
            } catch (err) {
                this.allInvoices = '';
                console.error('Error loading Invoices:', err);
                return err;
            }
        },
    },
});
